import ErrorStackParser from "error-stack-parser";
import {MiniEvent} from "@cdx/common";
import {throttle} from "es-toolkit/compat";
import cdxEnv from "../env";
import {postRequest} from "./request";

export const exceptionEvent = new MiniEvent();

const throttledRequest = throttle(
  ({stackFrames, msg}) =>
    postRequest("/services/send-error", {
      stackFrames,
      message: msg,
      appVersion: cdxEnv.DEPLOYMENT_LABEL,
    }),
  1000
);

export const postError = (error, msg) => {
  try {
    throttledRequest({stackFrames: ErrorStackParser.parse(error), msg});
  } catch (e) {
    console.error("failed to send", error);
    throw e;
  }
};

window.onerror = (msg, file, line, col, error) => {
  if (msg === "Script error.") return;
  if (msg.indexOf("ResizeObserver loop") >= 0) return;
  if (msg.indexOf("Minified exception occurred") >= 0) return;
  if (msg.indexOf("Cannot read property '_currentElement'") >= 0) return;
  setTimeout(() => {
    exceptionEvent.emit();
  });
  const getStackFrames = () => {
    if (!error)
      return [{fileName: file, lineNumber: line, columnNumber: col, functionName: "unknown"}];
    try {
      return ErrorStackParser.parse(error);
    } catch {
      console.error(error);
      return [{fileName: file, lineNumber: line, columnNumber: col, functionName: "unknown"}];
    }
  };

  const stackFrames = getStackFrames();
  throttledRequest({stackFrames, msg});
};

window.addEventListener("unhandledrejection", (event) => {
  if (event.reason instanceof Error) {
    try {
      throttledRequest({
        stackFrames: ErrorStackParser.parse(event.reason),
        msg: `unhandled rejection: ${event.reason.message}`,
      });
    } catch (e) {
      console.error("failed to send", event.reason);
      throw e;
    }
  } else {
    throttledRequest({stackFrames: [], msg: JSON.stringify(event.reason)});
  }
});
